import {LatestDeviceState} from "../shared/models/single-device.model";

export const ICONS_PATH = "assets/media/netop/";
export const ICONS_TOPOLOGY_PATH = 'assets/media/netop/topology/';
export const UNKNOWN_ICON_PATH = 'assets/media/netop/topology/question-mark.svg';
export const ICONS_MULTI_CLIENTS_PATH = 'assets/media/netop/topology/multi-';
export const RED_RSSI = '-red.svg';
export const YELLOW_RSSI = '-yellow.svg';
export const GREEN_RSSI = '-green.svg';
export const CLIENTS_TOOLTIP_DOT = 'assets/media/netop/topology/tplg-dot';
export const HAND_CLICK_PATH = 'assets/media/netop/actions/hand-click.svg';
export const HEALTH_DOT_PATH = 'assets/media/netop/topology/health-dot';
export const HEALTH_DOT_OK_PATH = `${HEALTH_DOT_PATH}-ok.svg`;
export const HEALTH_DOT_WARNING_PATH = `${HEALTH_DOT_PATH}-warning.svg`;
export const HEALTH_DOT_ERROR_PATH = `${HEALTH_DOT_PATH}-error.svg`;
export const HEALTH_DOT_CRITICAL_PATH = `${HEALTH_DOT_PATH}-critical.svg`;
export const HEALTH_DOT_UNDEFINED_PATH = `${HEALTH_DOT_PATH}-undefined.svg`;
export const FABRICS_ICON_PATH = 'assets/media/netop/fabrics_2x.png';
export const PROPERTIES_ICON_PATH = 'assets/media/netop/properties_2x.png';
export const ADD_PLUS_PATH = 'assets/media/netop/add-plus.png';
export const DELETE_ICON_PATH = 'assets/media/netop/actions/delete.svg';

export namespace HealthIcons {
  const base = 'assets/media/netop/health';
  export const GREEN = `${base}-green.png`;
  export const YELLOW = `${base}-yellow.png`;
  export const RED = `${base}-red.png`;
}

export namespace TopologyIcons {
  const BASE = 'assets/media/netop/topo-icons';
  export const CLOUD = `${BASE}/topo-cloud.png`;
  export const SDWAN = `${BASE}/topo-sdwan.png`;
  export const ROUTER = `${BASE}/topo-router.png`;
  export const SWITCH_STACK = `${BASE}/topo-switch-stack.png`;
  export const SWITCH = `${BASE}/topo-switch.png`;
  export const UNIDENTIFIED_DEVICE = `${BASE}/topo-ud.png`;
  export const UNIDENTIFIED_DEVICE_GROUP = `${BASE}/topo-ud-group.png`;
  export const ACCESS_POINT = `${BASE}/topo-ap.png`;
  export const ACCESS_POINT_GROUP = `${BASE}/topo-ap-group.png`;
  export const FIREWALL = `${BASE}/topo-firewall.png`;
  export const CAMERA = `${BASE}/topo-camera.png`;
  export const CELLULAR_GATEWAY = `${BASE}/meraki-cellular.svg`;
  export const VPC = `${BASE}/topo-vpc.png`;
  export const CLIENT_DESKTOP = `${BASE}/topo-clients-mac.png`;
  export const CLIENT_DESKTOP_GROUP = `${BASE}/topo-clients-mac-group.png`;
  export const CLIENT_TABLET = `${BASE}/topo-clients-ipad.png`;
  export const CLIENT_MOBILE = `${BASE}/topo-clients-iphone.png`;
  export const CLIENT_MOBILE_GROUP = `${BASE}/topo-clients-iphone-group.png`;
  export const CLIENT_UNKNOWN = `${BASE}/topo-clients-unknown.png`;
  export const CLIENT_GROUP = `${BASE}/topo-clients-group.png`;
}

export namespace ConnectionIcons {
  const BASE = 'assets/media/netop';
  export const WIRED = `${BASE}/wired.png`;
  export const WIRELESS = `${BASE}/wireless.png`;
}

export namespace StatusIcons {
  export const ALERT = `${ICONS_PATH}alert.png`;
  export const UNAVAILABLE = `${ICONS_PATH}unavailable.png`;
  export const HIBERNATE = `${ICONS_PATH}hibernate.png`;
  export const OFFLINE = `${ICONS_PATH}offline.png`;
  export const ONLINE = `${ICONS_PATH}online.png`;
  export const UNREACHABLE = `${ICONS_PATH}unreachable.png`;
  export const UNKNOWN = `${ICONS_PATH}question-mark.png`;
  export const IDLE = `${ICONS_PATH}idle.png`;

  export function fromDeviceState(state: LatestDeviceState): string {
    switch (state) {
      case LatestDeviceState.Alerting:
        return ALERT;
      case LatestDeviceState.Disabled:
        return UNAVAILABLE;
      case LatestDeviceState.Hibernating:
        return HIBERNATE;
      case LatestDeviceState.Offline:
        return OFFLINE;
      case LatestDeviceState.Online:
        return ONLINE;
      case LatestDeviceState.Unreachable:
        return UNREACHABLE;
      case LatestDeviceState.Idle:
          return IDLE;
      default:
        return UNKNOWN;
    }
  }
}

export namespace SeverityIcons {
  const BASE = `${ICONS_PATH}severity_`;
  export const CRITICAL = `${BASE}critical.png`;
  export const HIGH = `${BASE}high.png`;
  export const MEDIUM = `${BASE}medium.png`;
  export const LOW = `${BASE}low.png`;
  export const NOT_COMPUTED = `${BASE}not_computed.png`;
}
